import React, { useState, useEffect, useContext } from "react";

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Container,
  Row,
  Col,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Text,
  View,
  PDFDownloadLink,
  Page,
  Document,
} from "@react-pdf/renderer";
import BareLayout from "layouts/Bare.js";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useForm, Controller } from "react-hook-form";
import compose from "../../../styles/compose";
import styles from "./WorkReportReview.module.scss";
import Report from "../../../components/Pdf/Report";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { db, storageRef } from "../../../firebase";
import {
  collection,
  getDocs,
  addDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  doc,
  where,
  query,
} from "firebase/firestore";
import { AuthContext } from "../../../providers/AuthProvider";
import { PDFViewer } from "@react-pdf/renderer";
import { getDownloadURL } from "firebase/storage";

const WorkReportShow = () => {
  // const { register, handleSubmit, watch, errors, control } = useForm();
  const { id } = useParams();
  const location = useLocation();
  // const history = useHistory();
  // const [subTotal, setSubTotal] = useState(0);
  // const [taxTotal, setTaxTotal] = useState(0);
  // const [total, setTotal] = useState(0);
  const [data, setData] = useState();
  const [currentUser, setCurrentUser] = useState();
  const [loading, setLoading] = useState(true);
  const context = useContext(AuthContext);
  //ログイン情報格納処理
  useEffect(() => {
    if (!context?.userInfo?.uid) {
      return <></>;
    }
    setCurrentUser(context.userInfo);
  }, [context]);

  const fetchReportData = async () => {
    try {
      const reportsCollectionRef = collection(
        db,
        "docs",
        currentUser.uid,
        "reports"
      );
      const q = query(reportsCollectionRef, where("id", "==", id));

      const querySnapshot = await getDocs(q);
      let d;
      querySnapshot.forEach((doc) => {
        d = doc.data();
        setData(d);
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(async () => {
    if (currentUser) {
      if (location?.state?.reportData) {
        setData(location.state.reportData);
        setLoading(false);
      } else {
        await fetchReportData();
        setLoading(false);
      }
    }
  }, [currentUser]);

  return (
    <BareLayout>
      {!loading && data ? (
        <PDFViewer width="100%" height="100%">
          <Report data={data} title="稼働報告書" />
        </PDFViewer>
      ) : (
        <p></p>
      )}
    </BareLayout>
  );
};

export default WorkReportShow;
